var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-table-container"},[_c('b-table',{attrs:{"sticky-header":"","items":_vm.items,"fields":_vm.fields,"head-variant":"dark","borderless":"","hover":"","striped":""},scopedSlots:_vm._u([{key:"cell(No)",fn:function(data){return [_vm._v(" "+_vm._s(data.index + 1)+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }